import { connect } from "react-redux";
import Store from "@/store"
function Project(props) {
  const language = Store.getState().language
  console.log(language)
  return <div style={{ position: "relative", paddingBottom: "117px" }} >
    {language == 'ko' && <>
      <div style={{ position: "relative", zIndex: 1 }}>
        <h2 className="cs-title_title title_titlef">
          <div className="min-titlef-blue"></div>
          프로젝트 기본 정보
        </h2>
        <div className="cs-bid_info">
          <table className="table">
            <tbody>
              <tr><td className="label">프로젝트</td><td>강진 DACCUL-CO2 Project</td></tr>
              <tr><td className="label">공급자</td><td>(주)로우카본</td></tr>
              <tr><td className="label">적용 기술</td><td>Direct Air Carbon Capture and Utilization(DACCU)</td></tr>
              <tr><td className="label">진행 상태</td><td>시스템 구축 중</td></tr>
              <tr><td className="label">위치 정보</td><td>대한민국 전라남도 강진군 성전면</td></tr>
              <tr><td className="label">기술 구분</td><td>Utilization</td></tr>
              <tr><td className="label">방법론</td><td>Direct Air Carbon Capture and Utilization v1.0</td></tr>
            </tbody>
          </table>
        </div>
        <h2 className="cs-title_title title_titlef">
          <div className="min-titlef-blue"></div>
          프로젝트 추가 정보
        </h2>
        <div className="cs-bid_info" style={{"lineHeight":"28px"}}>
          ㈜로우카본은 대한민국 전라남도 강진군 성전면에 위치한, CCUS 및 DAC 기술을 보유한, 기후테크 선도 기업 입니다.<br />
          본 프로젝트는 DACCU 기술을 이용하여, 대기중 이산화탄소를 포집하여, 액화탄산(Liquified CO₂)을 제조하는 프로젝트 입니다.<br />
          모듈 하나당 연간 300톤의 DAC 성능을 가지며, 적층형 모듈 형태로 고객사의 요구에 따라 포집량과 시스템 확장이 가능합니다.
        </div>
      </div>
      <img style={{ position: "absolute", left: 355, top: 60, width: "895px" }} src="/assets/img/1744766938035.png" alt="" />
    </>}
    {language == 'en' && <>
      <div style={{ position: "relative", zIndex: 1 }}>
        <h2 className="cs-title_title title_titlef">
          <div className="min-titlef-blue"></div>
          Project Info
        </h2>
        <div className="cs-bid_info">
          <table className="table">
            <tbody>
              <tr><td className="label">Project</td><td>Gangjin DACCUL-CO2 Project</td></tr>
              <tr><td className="label">Supplier</td><td>LowCarbon Co., Ltd.</td></tr>
              <tr><td className="label">Process</td><td>Direct Air Carbon Capture and Utilization(DACCU)</td></tr>
              <tr><td className="label">Project Status</td><td>System under construction</td></tr>
              <tr><td className="label">Location</td><td>Gangjin-gun, Jeollanam-do, Seongjeon-myeon, Republic of Korea</td></tr>
              <tr><td className="label">Durability</td><td>Utilization</td></tr>
              <tr><td className="label">Methodology</td><td>Direct Air Carbon Capture and Utilization v1.0</td></tr>
            </tbody>
          </table>
        </div>
        <h2 className="cs-title_title title_titlef">
          <div className="min-titlef-blue"></div>
          Project Summary
        </h2>
        <div className="cs-bid_info">
          LowCarbon is a South Korean company specializing in Direct Air<br />
          Capture (DAC) technology. This project aims to produce liquefied CO₂<br />
          (LCO₂) using DAC, replacing conventionally sourced LCO₂ derived from<br />
          fossil fuels. Each DAC module is capable of capturing 300 metric tons <br />
          of CO₂ per year, and the facility will be expanded based on customer<br />
          demand.
        </div>
      </div>
      <img style={{ position: "absolute", left: 355, top: 60, width: "895px" }} src="/assets/img/WechatIMG13525.png" alt="" />
    </>
    }
  </div>
}

export default connect((state) => {
  return {
    userInfo: state.userInfo,
    isLogin: state.isLogin,
    language: state.language,
  };
})(Project);